import { LeftLegendHoverArea } from '@/apps/mwd-v2/types/legends';
import Alert from '@/assets/icons/Alert';

import styles from './LegendLeft.module.css';

type PlcInteractiveIconProps = {
  handleIconMouseEvent: (area: LeftLegendHoverArea) => void;
  scrollToTime: () => void;
  werklijnId: string;
  variant: 'small' | 'big';
};

export default function PlcInteractiveIcon({
  handleIconMouseEvent,
  scrollToTime,
  werklijnId,
  variant,
}: Readonly<PlcInteractiveIconProps>) {
  const iconSize = variant === 'small' ? '20px' : '24px';

  return (
    <button
      type='button'
      className={styles.legendLeftVeiligheidsButtonStyle}
      onMouseEnter={() => handleIconMouseEvent('plc')}
      onMouseLeave={() => handleIconMouseEvent('main')}
      onClick={scrollToTime}
      aria-label='Navigeer naar eerste perronlengte conflict'
      id={`eerste-plc-in-werklijn-${werklijnId}`}
      data-testid={`eerste-plc-in-werklijn-${werklijnId}`}
    >
      <Alert className={styles.legendLeftVeiligheidsIconAddendumStyle} width={iconSize} height={iconSize} />
    </button>
  );
}
